import React from 'react';
import PropTypes from 'prop-types';

import OptionRow from './OptionRow';

class FilterField extends React.Component {
    render() {
        const {id, name, filterOptions, choiceCallback, filterKey} = this.props;

        return (
            <div className="filter__sub collapse" id={id} data-bs-parent="#filter">
                <div className="filter__in">
                    <div className="filter__select">
                        <span className="filter__label">{name}</span>
                        <ul className="filter__options">
                            {filterOptions && filterOptions.map((filterOption) => {
                                return (
                                    <OptionRow key={filterOption.id} choiceCallback={choiceCallback} filterOption={filterOption} filterKey={filterKey}/>
                                )
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

FilterField.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    filterOptions: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
            slug: PropTypes.string.isRequired,
        })
    ),
    choiceCallback: PropTypes.func.isRequired,
    filterKey: PropTypes.string.isRequired,
};

export default FilterField;